export default __webpack_public_path__ + "static/media/arab.e006a17d.png";